<div class="sidebar">
  <p class="sidebar__unit">{{ unitOfMeasure }}</p>
  <ngx-slider
    [(value)]="originalValue"
    [options]="options"
    (valueChange)="changeValue($event)"
  ></ngx-slider>
  <div class="sidebar__content">
    <ng-content></ng-content>
  </div>
</div>
